/* eslint-disable no-console */
import Vue from 'vue'
import { register } from 'register-service-worker'

const canRegister =
  process.env.NODE_ENV === 'production' ||
  process.env.NODE_ENV === 'development'
if (canRegister === true) {
  register(`${process.env.BASE_URL}sw.js`, {
    ready(registration) {
      Vue.$sw = Vue.prototype.$sw = registration
      if (window.navigator.serviceWorker.controller === null) {
        window.location.reload()
      }
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      )
    },
    sync() {
      console.log('SYNC')
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    },
    updated(registration) {
      document.dispatchEvent(new CustomEvent('swUpdated', registration))
      console.log('New content is available; please refresh.', registration)
    },
    updatefound(registration) {
      console.log('New content is downloading.')
    },
    registered(registration) {
      setInterval(() => {
        registration.update()
      }, 1000 * 60) // e.g. hourly checks
    },
  })  
}
